module.exports = __webpack_public_path__ + "static/media/icomoon.47296f17.woff";